import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system';
import { inputTheme } from './Input';
import { Space } from '../../types';

const baseStyle = defineStyle({
  ...inputTheme.baseStyle?.field,
  minH: Space.SPACE_28,
  verticalAlign: 'top',
  paddingStart: Space.SPACE_3,
  paddingEnd: Space.SPACE_3,
});

const variants = {
  outline: defineStyle(() => inputTheme.variants?.outline().field ?? {}),
  flushed: defineStyle(() => inputTheme.variants?.flushed().field ?? {}),
  filled: defineStyle(() => inputTheme.variants?.filled().field ?? {}),
};

const sizes = {
  xs: inputTheme.sizes?.xs.field ?? {},
  sm: inputTheme.sizes?.sm.field ?? {},
  md: inputTheme.sizes?.md.field ?? {},
  lg: inputTheme.sizes?.lg.field ?? {},
};

export const Textarea = defineStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: 'md',
    variant: 'outline',
  },
});
